import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getETLLogs(
  oauthTokenHeader: string,
  rpp?: number,
  rid?: any,
  status?: string[],
  method?: string[],
  from?: any,
  to?: any,
  processId?: any,
) {
  const params = new URLSearchParams();

  if (rpp !== undefined) params.append("rpp", rpp.toString());
  if (rid !== null) params.append("run_id", rid.toString());
  if (status !== undefined && status.length > 0) {
    status.forEach((s) => params.append("status", s));
  }
  if (method !== undefined && method.length > 0) {
    method.forEach((m) => params.append("method", m));
  }
  if (from !== null) params.append("from", from);
  if (to !== null) params.append("to", to);
  if (processId !== null) params.append("process_id", processId);

  const queryString = params.toString();
  return fetchWrapper.get(
    `${apiUrl}/admin/processes/logs/?${queryString}`,
    oauthTokenHeader,
  );
}

// This function is used to fetch logs for export to CSV
function getETLLogsForExportToCSV(oauthTokenHeader: string, rpp?: number) {
  return fetchWrapper.get(
    `${apiUrl}/admin/processes/logs/?rpp=${rpp}`,
    oauthTokenHeader,
  );
}

function getETLLogById(runId: number, oauthTokenHeader: string) {
  return fetchWrapper.get(
    `${apiUrl}/admin/processes/logs/${runId}/`,
    oauthTokenHeader,
  );
}

function getDBTables(
  oauthTokenHeader: string,
  selectedSource: any,
  selectedDestination: any,
) {
  return fetchWrapper.get(
    `${apiUrl}/admin/processes/get_tables/?source=${selectedSource}&destination=${selectedDestination}`,
    oauthTokenHeader,
  );
}

function postMigrate(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/admin/processes/migrate/`,
    data,
    oauthTokenHeader,
  );
}

function getBrands(oauthTokenHeader: string, websiteSharedUID: string[]) {
  const params = new URLSearchParams();

  // Append each website_shared_uid as a separate query parameter
  websiteSharedUID.forEach((uid) => {
    params.append("website_shared_uid", uid);
  });

  // Build the full URL with the parameters
  const url = `${apiUrl}/admin/processes/brands_data/?${params.toString()}`;

  // Fetch using the constructed URL
  return fetchWrapper.get(url, oauthTokenHeader);
}

function postBrands(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/admin/processes/brands_data/`,
    data,
    oauthTokenHeader,
  );
}

function runProcessLogs(ids: any, oauthTokenHeader: string) {
  return fetchWrapper.post(
    `${apiUrl}/admin/processes/logs/`,
    ids,
    oauthTokenHeader,
  );
}

export const etlLogsService = {
  getETLLogs,
  getETLLogsForExportToCSV,
  getETLLogById,
  getDBTables,
  postMigrate,
  getBrands,
  postBrands,
  runProcessLogs,
};
